/**
 * VMACD — MACD do Volume.
 *
 * Migrado do Silverlight (GraficoDePrata/Formulas/FMLTrend.cs, classe FML.VMACD).
 * É o MACD clássico aplicado ao VOLUME em vez do preço. Painel próprio,
 * 2 linhas + histograma:
 *
 *   DIFF = EMA(VOL, SHORT) − EMA(VOL, LONG)
 *   DEA  = EMA(DIFF, M)
 *   MACD = DIFF − DEA                        (SetAttrs "COLORSTICK")
 *
 * Usa VOLUME → desembrulhar o objeto {volume,direction} do indicador Volume no
 * pipeline (família E1).
 *
 * O EMA do engine é DMA(f, 2/(N+1)) com seed out[0] = f[0] — portanto NÃO tem
 * warm-up NaN: as três séries emitem desde a barra 0 (na barra 0 as duas EMAs
 * valem VOL[0], então DIFF/DEA/MACD saem 0). Confirmado nos 5 oráculos
 * (nonNull = 2000). Paridade em __tests__/vmacd.silverlight.test.js.
 */
import { ema, sub } from "./silverlightDsl";
import { VMACD as defaultOptions } from "./defaultOptionsForComputation";

const unwrapVolume = (raw) =>
  typeof raw === "object" && raw !== null ? raw.volume : raw;

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { short, long, m } = options;
    const vol = data.map((d) => {
      const v = unwrapVolume(d.volume);
      return Number.isFinite(v) ? v : NaN;
    });

    // Ordem do engine preservada.
    const diff = sub(ema(vol, short), ema(vol, long));
    const dea = ema(diff, m);
    const macd = sub(diff, dea);

    return macd.map((mv, i) => {
      const diffOut = Number.isFinite(diff[i]) ? diff[i] : undefined;
      const deaOut = Number.isFinite(dea[i]) ? dea[i] : undefined;
      const macdOut = Number.isFinite(mv) ? mv : undefined;
      if (
        diffOut === undefined &&
        deaOut === undefined &&
        macdOut === undefined
      )
        return undefined;
      return {
        diff: diffOut,
        dea: deaOut,
        macd: macdOut,
        // COLORSTICK do engine colore por SINAL (FormulaArea.cs), não por
        // inclinação — mesma regra do DIDIHIST/DDI.
        direction: macdOut !== undefined && macdOut > 0 ? "up" : "down",
      };
    });
  }

  calculator.undefinedLength = function () {
    // EMA com seed f[0] não gera warm-up NaN — emite desde a barra 0.
    return 0;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
